"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_placeholder__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-6{opacity:0.1;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:none;}.cls-4{fill:#f4f4f4;}.cls-5{fill:#e60000;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 41.5,
    y1: 108.71,
    x2: 176,
    y2: 108.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), /*#__PURE__*/React.createElement("title", null, "placeholder-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 96,
    cy: 96,
    r: 80
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.5,154.56l113.06-113-.07-.09a80,80,0,0,1-113,113.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    className: "cls-3",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.54,150.45,103,98.91h56.05V93.09H103l51.56-51.56q-2-2.13-4.11-4.11L98.91,89V33H93.09V89L41.5,37.41c-1.42,1.32-2.8,2.69-4.12,4.11L89,93.09H33v5.82H89L37.43,150.46q2,2.13,4.11,4.11L93.09,103v56h5.82v-56l51.51,51.51Q152.55,152.58,154.54,150.45Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M160,162.84H32A2.83,2.83,0,0,1,29.17,160V32A2.82,2.82,0,0,1,32,29.17H160A2.82,2.82,0,0,1,162.83,32V160A2.83,2.83,0,0,1,160,162.84ZM34.83,157.17H157.17V34.84H34.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.83,
    y: 32.83,
    width: 122.33,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,160.84H32A2.83,2.83,0,0,1,29.17,158v2A2.83,2.83,0,0,0,32,162.84H160a2.83,2.83,0,0,0,2.83-2.84v-2A2.83,2.83,0,0,1,160,160.84Z",
    transform: "translate(0 0)"
  }))));
}

var _default = ic_placeholder__dark;
exports.default = _default;